import { Radar } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const RadarIcon = createLucideIcon(Radar);
